var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3"},[_c('div',{},[_c('p',{staticClass:"error--text text-subtitle-2  "},[_vm._v(_vm._s(_vm.errors.message)+" !")])])])}
var staticRenderFns = []

export { render, staticRenderFns }